export const extConfig = {
    bold: false,
    italic: false,
    strikethrough: false,
    underline: false,
    bulletList: false,
    orderedList: false,
    horizontalRuler: false,
    link: false,
    emote: false,
    gif: false,
    deviation: false,
    deviationThumb: false,
    allowUploads: false,
    daVideo: false,
    gallery: false,
    anchor: false,
    spinner: false,
    blockDragging: false,
    blockquote: false,
    heading: false,
    hashtag: false,
    mention: false,
    paste: true,
    textAlignment: false,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: false,
    indent: {
        captureTab: false
    },
    muro: false,
    characterCount: true,
    disableHardBreak: true,
    damz: true
};

//# sourceMappingURL=config.js.map